import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router";
import { Progress, Button, ButtonGroup } from "reactstrap";
import { useTranslation } from "react-i18next";
import { sumValueInCart, changeCheckoutForm } from "../../../../../../actions";
import { getFreeLimit, isFreeOrderEligible } from "../../../../../../common/util";


const CartProgress = ({
  valInCart,
  countTitlesInCart,
  cartType,
  dbUser,
  form,
  changeCheckoutForm,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(()=>{
  return localStorage.getItem("cartProgressCollapsed") === "true"
})

useEffect(()=>{
  localStorage.setItem("cartProgressCollapsed", collapsed)
}, [collapsed])

  const isReaderPage =
    location.pathname.startsWith("/read/") ||
    location.pathname === "/literature/epub-reader";

  if (countTitlesInCart === 0 || !dbUser || isReaderPage) {
    return null;
  }

  const freeLimit = getFreeLimit(dbUser);
  
  const percentage =
    freeLimit > 0 ? Math.min((valInCart / freeLimit) * 100, 100) : 0;

  const setCartType = (type) => {
    const newForm = { ...form, type };
    changeCheckoutForm(newForm);
  };

  const handleFreeClick = (e) => {
    e.preventDefault();
    if (dbUser.alreadyOrderedMo) {
      alert(t("cart-already-ordered"));
    } else if (
      !isFreeOrderEligible({ dbUser, valInCart, countTitlesInCart })
    ) {
      alert(t("reduce-cart", { freeLimit }));
    } else {
      setCartType("free");
    }
  };

  const handlePayClick = (e) => {
    e.preventDefault();
    setCartType("pay");
  };

  const cartInfoLine = cartType === "free" ? (
            <>
              <span className="cart-progress-text">
                🛒 ${valInCart.toFixed(2)} / ${freeLimit} {t("free")}
              </span>
              <Progress className="cart-progress-bar" value={percentage} />
            </>
          ) : (
            <span className="cart-progress-text">
             🛒 ${Math.min(valInCart, freeLimit).toFixed(2)} {t("free")} | $
              {Math.max(valInCart - freeLimit, 0).toFixed(2)} {t("pay")}
            </span>
          ); 
  return (
    <div className={`cart-progress-container ${collapsed ? "collapsed" : ""}`}>
      
      
 
      <Link to="/cart" className="cart-progress-link">
        <div className="cart-progress">
         {collapsed ? <>🛒 ${valInCart.toFixed(2)}</> : cartInfoLine}
        </div>
      </Link>{!collapsed && (
<>
      <ButtonGroup className="cart-type-toggle">
        <Button
          color={cartType === "free" ? "warning" : "secondary"}
          onClick={handleFreeClick}
          size="sm"
        >
          {t("free")}
        </Button>
        <Button
          color={cartType !== "free" ? "warning" : "secondary"}
          onClick={handlePayClick}
          size="sm"
        >
          {t("pay")}
        </Button>
      </ButtonGroup>
      </>)}
      <Button
    className="cart-progress-collapse"
    onClick={() => setCollapsed(!collapsed)}
    title={t("close")}
  >
       {collapsed ? "☰" : "✕"}
  </Button>
    </div>
  );
};

const mapStateToProps = ({ cart, user }) => ({
  valInCart: sumValueInCart(cart),
  countTitlesInCart: cart.selectedBooks.length,
  cartType: cart.checkoutForm.type,
  form: cart.checkoutForm,
  dbUser: user.dbUser,
});

const mapDispatchToProps = (dispatch) => ({
  changeCheckoutForm: (form) => dispatch(changeCheckoutForm(form)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartProgress);
